// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c5fc37d9","38":"253fd8a8","44":"e4019b7b","239":"e928d88c","340":"11a9a38f","365":"cc9df7ae","438":"81ae18bb","455":"8894a7d0","462":"7b7b520e","599":"aefb8246","604":"0bcd82ee","722":"cda98d70","974":"0e8eca95","977":"1d5b75a8"}[chunkId] + ".chunk.js";
};